module.exports = {
    controller: searchUsaSectionNotesController,
    templateUrl: 'search/components/pages/search-usa-section-notes.html'
};

searchUsaSectionNotesController.$inject = [
    '$analytics', 
    '$location',
    'common',
    'notificationsService', 
    'annotationsDataService'
];

function searchUsaSectionNotesController(
    $analytics, 
    $location,
    common,
    notificationsService, 
    annotationsDataService
) {

    var vm = {
        $onInit: attached,
        $onDestroy: detached,
        isLoading: false,
        query: {
            QueryString: ''
        },
        results: null,
        numberToRoman: common.formatting.numberToRoman,
        scrollToDocument: scrollToDocument,
        search: search
    };

    function attached() {
        vm.query.QueryString = $location.search().query;
        $analytics.pageTrack('/usa-notes-search');
        loadSearch();
        notificationsService.subscribe('filter_date_changed', loadSearch);
    }

    function detached() {
        notificationsService.unsubscribe('filter_date_changed', loadSearch);
    }

    function scrollToDocument(result) {
        document
            .querySelector('.Note-' + result.NomenclatureLevel + '-' + result.SectionNumber)
            .scrollIntoView({ behavior: 'smooth', block: 'start' });
        // console.log('TODO: scroll to document', result);
    }

    return vm;

    function search(query) {
        $location.path('/search/usa-section-notes').search(query);
    }

    function loadSearch() {
        if (vm.query.QueryString && vm.query.QueryString.length > 1) {
            vm.isLoading = true;
            annotationsDataService.searchUsaSectionNotes(vm.query.QueryString)
                .then(function(data) {
                    vm.isLoading = false;
                    vm.results = data;
                });
        }
    }
}